import { useState, useEffect, useMemo } from "react";
import { useInvoice } from "../../stores/useInvoice";

import { Chart as ChartJS, Tooltip, Legend, ArcElement } from "chart.js";
import { Doughnut, Pie } from "react-chartjs-2";
import { StyledDashBoardPieChart } from "./dashboardDoughnutChart.styled";
import { Box, Typography, useTheme } from "@mui/material";

ChartJS.register(ArcElement, Tooltip, Legend);

type DashBoardPieChartProps = {
  chartData: number;
};

export const DashBoardDoughnutChart = ({
  chartData,
}: DashBoardPieChartProps) => {
  const theme = useTheme();

  const data = {
    labels: [],
    datasets: [
      {
        label: "Euro",
        data: [100 - chartData, chartData],
        backgroundColor: [theme.color.main, theme.contrast.lighter],
        borderColor: [theme.color.main, theme.contrast.lighter],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    cutout: "80%",
    plugins: {
    tooltip: {
      callbacks: {
        label: (context: any) => `${context.raw.toFixed(2)}%`,
      },
    },
    datalabels: {
      formatter: (value: any) => `${value}%`,
    },
  },
  };

  useEffect(() => {
    console.log(chartData);
  }, []);

  return (
    <StyledDashBoardPieChart>
      <Doughnut data={data} options={options} />;
      <Box className="chartData">
        <Typography variant="h3">Marge</Typography>
        <Typography variant="h3">omzet/goederen</Typography>
        <Typography variant="h2">{Number(100 - chartData).toFixed(2)}%</Typography>
      </Box>
    </StyledDashBoardPieChart>
  );
};
